import './react';
import './react-dom';
import './react-dom-client';
import './react-router';
import './react-redux';

evite.resolve('react');
